import React from 'react';
import './SkeletonLoader.css';

const SkeletonLoader = () => (
  <div className="skeleton-loader">
    {[1, 2, 3, 4, 5].map(i => (
      <div key={i} className="sk-module">
        <div className="sk-module-header"></div>
        {[1, 2, 3].map(j => (
          <div key={j} className="sk-row">
            <div className="sk-cell matiere sk-block"></div>
            <div className="sk-cell input sk-block"></div>
            <div className="sk-cell input sk-block"></div>
            <div className="sk-cell input sk-block"></div>
          </div>
        ))}
        <div className="sk-footer">
          <div className="sk-cell sk-block" style={{ width: 120 }}></div>
        </div>
      </div>
    ))}
    <div className="sk-final"></div>
  </div>
);

export default SkeletonLoader;
